import * as yup from "yup";
import i18next from "i18next";
import { InvoiceValidationSchemaMX } from "./types";
import { VALIDATION_REGEX } from "utils/constants";

const requiredString = yup.string().required("");
const optionalString = yup.string().optional();

const invoiceNumber = (save: boolean) =>
  yup
    .string()
    .matches(
      VALIDATION_REGEX.regInvoiceMX,
      i18next.t("validations:enterValidFormat")
    )
    .min(36, i18next.t("invoice:invoiceNumberError"))
    .matches(
      VALIDATION_REGEX.regInvoiceMX2,
      i18next.t("validations:specialCharacters")
    )
    .concat(save ? optionalString : requiredString);

const emisionDate = (save: boolean) =>
  yup
    .string()
    .test("requireDatePicker", "", (value) => (save ? true : !!value));

export const validationSchemaMX = (
  save: boolean
): yup.SchemaOf<InvoiceValidationSchemaMX> => {
  return yup.object({
    emisionDate: emisionDate(save),
    invoiceNumber: invoiceNumber(save),
  });
};
